/**
 * 设置session
 * @param {string} name 需要设置的name
 * @param {any} params 参数
 */
export function setSStorage (name, params) {
  let data = params
  // 如果是对象则stringfy
  if (typeof data === 'object') {
    data = JSON.stringify(params)
  }
  window.sessionStorage.setItem(name, data)
}
/**
 * 清空token
 */
export function removeInvilidToken () {
  window.localStorage.removeItem('token')
  window.sessionStorage.removeItem('token')
}
/**
 * 获取session
 * @param {string} name 需要取的值
 */
export function getSStorage (name) {
  const storage =
    window.sessionStorage.getItem(name) || window.localStorage.getItem(name)
  let data = storage || ''
  if (!data || data === 'undefined' || data === '') {
    return ''
  }
  try {
    data = JSON.parse(data)
  } catch (err) {
    console.log()
  }
  // eslint-disable-next-line
  return data
}
/**
 * 移除session
 * @param {string} name 需要移除的name
 */
export function removeSStorage (name) {
  window.sessionStorage.removeItem(name)
}
/**
 * 设置localStorage
 */
export function setLStorage (name, params) {
  let data = params
  // 如果是对象则stringfy
  if (typeof data === 'object') {
    data = JSON.stringify(params)
  }
  window.localStorage.setItem(name, data)
}
/**
 * 获取localsession
 * @param {string} name 取值名
 */
export function getLStorage (name) {
  let data = window.localStorage.getItem(name) || ''
  if (!data || data === 'undefined' || data === '') {
    return ''
  }
  try {
    data = JSON.parse(data)
  } catch (err) {
    console.log()
  }
  return data
}



// WEBPACK FOOTER //
// ./src/utils/index.js